<template>
    <div id="WeekReport">
        <div class="data_head">
            <span class="text_panel">参数</span>
            <!-- <el-cascader
                v-model="measureNos"
                :options="paramOptions"
                :props="{value:'code',label:'name',children:'childHashSet',emitPath:false,multiple:true}"
                :show-all-levels="false"
                collapse-tags
            ></el-cascader> -->

             <el-cascader
             ref="cascaderAddr"
             @blur="handleAddressFun"

      v-model="value"
      :options="options"
      :props="{ multiple: true, checkStrictly: true }"
      :show-all-levels="false"
      clearable
      collapse-tags
      @change="changeLabel"
    ></el-cascader>


            <el-date-picker
                v-model="searchDate"
                align="right"
                type="date"
                value-format="yyyy-MM-dd"
            ></el-date-picker>
            <el-button type="primary" @click="search()" class="searchButton">周&nbsp;查&nbsp;询</el-button>
            <el-button type="primary" @click="download()" class="searchButton">下载</el-button>
        </div>

        <div class="table tableContent" style="height:625px;" id="table">
            <el-scrollbar style="height:100%">
                <div class="table_panel">
<!--                    <span>项目名称:{{projectName}}</span>-->
<!--                    <span>监测内容:{{objcontent}}</span>-->
<!--                    <span>{{date}}</span>-->
                </div>
                <el-table :data="list" style="width: 100%;" :header-cell-style="{background:'#335ABB',color:'#FFF'}" :row-style="{height:'36px'}" stripe>
                    <el-table-column prop="measureNo" label="测点编号"></el-table-column>
                    <el-table-column prop="normalRange" label="正常值范围"></el-table-column>
                    <el-table-column prop="maxValueTime" label="最大值时间"></el-table-column>
                    <el-table-column prop="maxValue" label="最大值">
                        <template slot-scope="scope">
                            <span>{{scope.row.maxValue | rounding}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="minValueTime" label="最小值时间"></el-table-column>
                    <el-table-column prop="minValue" label="最小值">
                        <template slot-scope="scope">
                            <span>{{scope.row.minValue | rounding}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="avgValue" label="平均值">
                        <template slot-scope="scope">
                            <span>{{scope.row.avgValue | rounding}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
Vue.filter("rounding", function (value) {
    if (!value) return "--";
    return parseFloat(value).toFixed(4);
});

export default {
    name: "WeekReport",
    data() {
        return {
            measureNos: [],
            paramOptions: [],
            list: [],
            searchDate: "",
            projectName: "",
            objcontent: "",
            date: "",
            value: [],
      shareScopeEnd: [],
      selectList:[],
      options: [
        {
          value: 'zhinan',
          label: '指南',
          children: [{
            value: 'shejiyuanze',
            label: '设计原则',
            children: [{
              value: 'yizhi',
              label: '一致'
            }, {
              value: 'fankui',
              label: '反馈'
            }, {
              value: 'xiaolv',
              label: '效率'
            }, {
              value: 'kekong',
              label: '可控'
            }]
          }, {
            value: 'daohang',
            label: '导航',
            children: [{
              value: 'cexiangdaohang',
              label: '侧向导航'
            }, {
              value: 'dingbudaohang',
              label: '顶部导航'
            }]
          }]
        }, {
          value: 'zujian',
          label: '组件',
          children: [{
            value: 'basic',
            label: 'Basic',
            children: [{
              value: 'layout',
              label: 'Layout 布局'
            }, {
              value: 'color',
              label: 'Color 色彩'
            }, {
              value: 'typography',
              label: 'Typography 字体'
            }, {
              value: 'icon',
              label: 'Icon 图标'
            }, {
              value: 'button',
              label: 'Button 按钮'
            }]
          }, {
            value: 'form',
            label: 'Form',
            children: [{
              value: 'radio',
              label: 'Radio 单选框'
            }, {
              value: 'checkbox',
              label: 'Checkbox 多选框'
            }, {
              value: 'input',
              label: 'Input 输入框'
            }, {
              value: 'input-number',
              label: 'InputNumber 计数器'
            }, {
              value: 'select',
              label: 'Select 选择器'
            }, {
              value: 'cascader',
              label: 'Cascader 级联选择器'
            }, {
              value: 'switch',
              label: 'Switch 开关'
            }, {
              value: 'slider',
              label: 'Slider 滑块'
            }, {
              value: 'time-picker',
              label: 'TimePicker 时间选择器'
            }, {
              value: 'date-picker',
              label: 'DatePicker 日期选择器'
            }, {
              value: 'datetime-picker',
              label: 'DateTimePicker 日期时间选择器'
            }, {
              value: 'upload',
              label: 'Upload 上传'
            }, {
              value: 'rate',
              label: 'Rate 评分'
            }, {
              value: 'form',
              label: 'Form 表单'
            }]
          }, {
            value: 'data',
            label: 'Data',
            children: [{
              value: 'table',
              label: 'Table 表格'
            }, {
              value: 'tag',
              label: 'Tag 标签'
            }, {
              value: 'progress',
              label: 'Progress 进度条'
            }, {
              value: 'tree',
              label: 'Tree 树形控件'
            }, {
              value: 'pagination',
              label: 'Pagination 分页'
            }, {
              value: 'badge',
              label: 'Badge 标记'
            }]
          }, {
            value: 'notice',
            label: 'Notice',
            children: [{
              value: 'alert',
              label: 'Alert 警告'
            }, {
              value: 'loading',
              label: 'Loading 加载'
            }, {
              value: 'message',
              label: 'Message 消息提示'
            }, {
              value: 'message-box',
              label: 'MessageBox 弹框'
            }, {
              value: 'notification',
              label: 'Notification 通知'
            }]
          }, {
            value: 'navigation',
            label: 'Navigation',
            children: [{
              value: 'menu',
              label: 'NavMenu 导航菜单'
            }, {
              value: 'tabs',
              label: 'Tabs 标签页'
            }, {
              value: 'breadcrumb',
              label: 'Breadcrumb 面包屑'
            }, {
              value: 'dropdown',
              label: 'Dropdown 下拉菜单'
            }, {
              value: 'steps',
              label: 'Steps 步骤条'
            }]
          }, {
            value: 'others',
            label: 'Others',
            children: [{
              value: 'dialog',
              label: 'Dialog 对话框'
            }, {
              value: 'tooltip',
              label: 'Tooltip 文字提示'
            }, {
              value: 'popover',
              label: 'Popover 弹出框'
            }, {
              value: 'card',
              label: 'Card 卡片'
            }, {
              value: 'carousel',
              label: 'Carousel 走马灯'
            }, {
              value: 'collapse',
              label: 'Collapse 折叠面板'
            }]
          }]
        }, {
          value: 'ziyuan',
          label: '资源',
          children: [{
            value: 'axure',
            label: 'Axure Components'
          }, {
            value: 'sketch',
            label: 'Sketch Templates'
          }, {
            value: 'jiaohu',
            label: '组件交互文档'
          }]
        }
      ]
     };
    },
    mounted: function () {
        this.$axios.get("/api/monitor/dataHistory/getMeasureByCode")
            .then((res) => {
                this.paramOptions = res.data.datas.values;
            });
        this.yestertay()
    },
    methods: {
        handleAddressFun(e,form,thsAreaCode){
            // console.log(this.$refs['cascaderAddr'].presentText  ,1111)
        },
        changeLabel(val) {
            console.log(val,555)
            if(val.length!==0){
                 console.log(this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels   ,1111)
            }

            // console.log(val,555)
      // 是否与上次的类型相同
      let changeFlag = false
      let changeItem = null
      if (this.shareScopeEnd.length == 0) {
        this.value = val
      } else {
        // 与原数组比对
        this.value.forEach((item) => {
          if (item[0] !== this.shareScopeEnd[0][0]) { // 一级标签不同
            changeFlag = true
            changeItem = item
          } else if (item[1] != this.shareScopeEnd[0][1]) { // 一级标签相同但是二级标签不同
            changeFlag = true
            changeItem = item
          } else if ((!item[2] && this.shareScopeEnd[0][2]) || (item[2] && !this.shareScopeEnd[0][2])) {
            changeFlag = true
            changeItem = item
          }
        })
      }
      if (changeFlag) {
        this.value = []
        this.value.push(changeItem)
      }
      this.shareScopeEnd = this.value
      this.selectList=[]
      this.shareScopeEnd.forEach(item=>{
          if(item.length===3){
              this.selectList.push(item[2])
          }
        //   else{
        //        this.$message({
        //             type: "error",
        //             message: '请选择编号',
        //         });
        //   }

      })

    //   console.log(this.shareScopeEnd,this.selectList,11111111)
    },
        yestertay(){
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth()+1;
            let day = date.getDate();
            this.searchDate = year + '-' + month + '-' + day;
        },
        search() {
            console.log(this.selectList,555)
            if(this.selectList.length===0){
                 this.$message({
                    type: "error",
                    message: '请选择编号',
                });
            }

            // this.$axios.get(`/api/monitor/report/getReport?code=${this.measureNos}&time=${this.searchDate}&type=2`)
            //     .then((res) => {
            //         this.list = res.data.datas.values;
            //     });
        },
        download() {
            const req = {
                type:"2"
            };
            this.$axios.post("/api/monitor/report/exportReport", req, { responseType: "blob" })
                .then((res) => {
                    let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'});
                    let downloadElement = document.createElement("a");
                    let href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = "周报表数据.xls";
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                });
        },
    },
};
</script>

<style>

    #table .el-scrollbar__wrap {
        overflow-x: hidden;
    }

    #WeekReport .el-cascader .el-input  .el-input__inner{
        color: #FFF;
        background-color: #3457DE;
    }

    #WeekReport .el-date-editor .el-input__inner{
        background-color: #3457DE;
        color: #FFF;
    }

    #WeekReport .el-table{
        color: #A7CCF6;
    }

    #WeekReport .el-table__row {
        background-color: #0B3A68 !important;
    }

    #WeekReport .el-table--striped .el-table__body tr.el-table__row--striped td{
        background-color: #021535;
    }

    #WeekReport .el-table td{
        border: unset;
    }

    #WeekReport .el-table th.is-leaf{
        border-bottom: none;
    }

    #WeekReport .el-date-editor--daterange.el-input__inner{
        background-color: #3457DE;
    }

    #WeekReport .el-date-editor .el-range-input{
        background-color: #3457DE;
        color: #FFF;
    }

    #WeekReport .el-date-editor .el-range-separator{
        background-color: unset;
        color: #FFF;
    }

</style>

<style scoped>
    @import url('../../assets/css/style.css');
</style>




// WEBPACK FOOTER //
// src/components/reportManage/WeekReport.vue